import { EventEmitter } from "events";


export class IndexedDbLogic {

    public static openDatabase(databaseName: string, version: number, reject: (reason?: any) => void, emitter?: EventEmitter): IDBOpenDBRequest {

        const dbRequest = indexedDB.open(databaseName, version);

        dbRequest.addEventListener("error", (dbEvent: any) => {
            emitter?.emit("error", dbEvent.target.error);
            reject(dbEvent.target.error);
        });

        return dbRequest;
    }

}